import React, { Component } from 'react';
import {Form,Select,Cascader,Table,message,Input ,Button,Popconfirm} from 'antd';
// import {
//     DownOutlined,
//     RightOutlined,
//   } from '@ant-design/icons';
import '../../static/css/index.css'
import { forbidMenu, deleteMenu, getMenuList } from '../../apis/api'

import moment from 'moment';

import EditMenu from './components/editMenu.js'

const { Option } = Select;

class Menu extends Component {
  constructor(props) {
    super(props);
    this.state={
      access_token:'',
      search_params:{},
      flag:false,
      menuList:[],
      currentPage:1,
      currentPageSize:10,
      total:0,
      visible:false,
      details:{},
      parentName_option:[],
      expandedRowKeys:[]
    }
  }

  componentDidMount(){
    this.setState({access_token:sessionStorage.getItem('access_token')},()=>{
       
        this.getMenuList();
        this.getParentMenuList();

    })
    
  }

  getParentMenuList = () =>{
    let _this=this;
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        parent_id:0,
        page:1,
        page_size:9999
    }
    getMenuList(params).then( (data)=> {
  
        if(data.code === 0){
          let list=data.content.list;

          list.map(item=>{
            if(item.child===1){
                item.isLeaf=false;
            }else{
                item.isLeaf=true;
            }
            return item;
          })

          _this.setState({ parentName_option:list })
          
        }else{

            message.error(data.message); 
        }
    });

  }

  loadData = selectedOptions => {
    const { access_token, parentName_option } = this.state;
    const targetOption = selectedOptions[selectedOptions.length - 1];
    targetOption.loading = true;
    let params={
        access_token:access_token,
        parent_id:targetOption.id,
    }
    
    getMenuList(params).then( (data)=> {
  
        if(data.code === 0){
          targetOption.loading = false;
          let list=data.content.list;
          list.map(item=>{
            if(item.child===1){
                item.isLeaf=false;
            }else{
                item.isLeaf=true;
            }
            // if(selectedOptions.length===2){
            //     item.isLeaf=true;
            // }
            return item;
          })
          targetOption.children = list;
          this.setState({
            parentName_option: [...parentName_option],
          });

        }else{

            message.error(data.message); 
        }
    });
  };

  getMenuList = (obj) =>{
    let _this=this;
    this.setState({flag:true})
    const { access_token, currentPage, currentPageSize } = this.state;
    let params={
        access_token:access_token,
        name:obj&&obj.name?obj.name:'',
        state:obj&&obj.state?obj.state:0,
        parent_id:obj&&obj.parent_id?obj.parent_id:null,
        page:currentPage,
        page_size:currentPageSize
    }
    getMenuList(params).then( (data)=> {

        if(data.code === 0){

            let menuList=data.content.list;
            let total=data.content.paging.total_record;
            menuList.map(item=>{
                if(item.child===1){
                    item.children=[];
                }
                return item;
            })
            _this.setState({ menuList, total, flag:false, expandedRowKeys:[] })    //expandedRowKeys:[]重置

        }else{

            message.error(data.message); 
        }
    });

  }

  getChildMenuList(id){
    let _this=this;
    const { access_token, menuList } = this.state;
    let params={
        access_token:access_token,
        parent_id:id,
        page:1,
        page_size:9999
    }
    getMenuList(params).then( (data)=> {
  
        if(data.code === 0){
            let list=data.content.list;
            list.map(item=>{
                if(item.child===1){
                    item.children=[];
                }
                return item;
            })
            if(list&&list.length){
                menuList.map(item=>{
                    if(item.id===id){
                        item.children=list;
                    }else{
                        item.children&&item.children.length&&item.children.map(itm=>{
                            if(itm.id===id){
                                itm.children=list;
                            }else{
                                itm.children&&itm.children.length&&itm.children.map(i=>{
                                    if(i.id===id){
                                        i.children=list;
                                    }
                                    return i;
                                })
                            }
                            return itm;
                        })
                    }
                    return item;
                })
            }

            _this.setState({ menuList })

        }else{

            message.error(data.message); 
        }
    });

  }

  //添加菜单
  addMenu = ()=>{
    this.setState({
        visible:true,
    });
  }

  //修改菜单
  updateMenu(obj){
    this.setState({details:obj,visible:true})
  }

  // 关闭弹窗
  handleCancel = (e) => {
    this.setState({
        visible:false,
        details:{}
    });
  }

  // 操作菜单
  operateMenu(record){
    let _this=this;
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        id:record.id,
        forbid:record.state===1?2:1
    }
    forbidMenu(params).then( (data)=> {
        if(data.code===0){
            if(record.state===1){
                message.success('禁用菜单成功！');
            }else if(record.state===2){
                message.success('启用菜单成功！');
            }
            _this.getMenuList(_this.state.search_params);
            _this.getParentMenuList();

        }else{
            message.error(data.message);
      }
    });
    
  }

  // 删除菜单
  deleteMenu(record){
    let _this=this;
    const { access_token } = this.state;
    let params={
        access_token:access_token,
        id:record.id,
    }
    deleteMenu(params).then( (data)=> {
        if(data.code===0){
            
            message.success('删除菜单成功！');
            _this.searchMenu();
            _this.getParentMenuList();

        }else{
            message.error(data.message);
      }
    });
    
  }

  //选择框展示选择的最后一个层级
  displayRender = (label) =>{
    return label[label.length - 1];
  }

  handleTableExpand = (expanded, record) => {
    let _this = this,expandedRowKeys=this.state.expandedRowKeys;
    if(expanded){//展开子集
        expandedRowKeys.push(record.id);
        _this.getChildMenuList(record.id);
    }else{//关闭
        let menuList=this.state.menuList;
        expandedRowKeys=expandedRowKeys.filter(key=>key!==record.id);
        menuList.map(item=>{
            if(item.id===record.id&&item.child===1){
                if(item.children&&item.children.length){
                    item.children.map(itm=>{
                        if(expandedRowKeys.indexOf(itm.id)!==-1){
                            expandedRowKeys=expandedRowKeys.filter(key=>key!==itm.id);
                        }
                        if(itm.children&&itm.children.length){
                            itm.children.map(i=>{
                                if(expandedRowKeys.indexOf(i.id)!==-1){
                                    expandedRowKeys=expandedRowKeys.filter(key=>key!==i.id);
                                }
                            });
                        }
                    });
                }
            }
        })//置空该级下的子级expandedRowKeys

        menuList.map(item=>{
            if(item.children&&item.children.length){
                item.children.map(itm=>{
                    if(itm.id===record.id&&itm.child===1){
                        if(itm.children&&itm.children.length){
                            itm.children.map(i=>{
                                if(expandedRowKeys.indexOf(i.id)!==-1){
                                    expandedRowKeys=expandedRowKeys.filter(key=>key!==i.id);
                                }
                            });
                        }
                    }
                });
            }
        })//置空该级下的子级expandedRowKeys
    }
    _this.setState({expandedRowKeys})
  }


  handleTableChange = pagination => {
    var _this = this;
    const current = pagination.current || 1;
    this.setState({ currentPage: current},()=>{
       _this.getMenuList(_this.state.search_params);
    });
  }

  searchMenu = () =>{
    let _this=this;
    _this.props.form.validateFields((err, values) => {
      if(err) {
          console.log('submit error:' ,err);
      }else {
        values.parent_id=values.parent_id&&values.parent_id.length?values.parent_id[values.parent_id.length-1]:'';
        values.state=values.state?values.state:0;
        // console.log(values)
        _this.setState({currentPage:1, search_params:values},()=>{
            _this.getMenuList(values);
        })
      }
    });
  }

  //新增编辑之后加载表格数据
  reloadSearchMenu = () =>{
    this.getMenuList(this.state.search_params);
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const {currentPage, curPageSize, total, menuList, flag, visible, details, parentName_option} = this.state;

    const columns = [{
        title: '',
        dataIndex: '',
        width:'60px',
        align:'center',
    // }, {
    //     title: '菜单uuid',
    //     dataIndex: 'uuid',
    //     width:'150px',
    //     align:'center',
    }, {
        title: '菜单名称',
        dataIndex: 'name',
        width:'120px',
        align:'center',
    }, {
      title: '父级菜单名称',
      dataIndex: 'parent_name',
      width:'120px',
      align:'center',
      render:text => (<span>{(!text)?'无':text}</span>)
    }, {
      title: '菜单类型',
      dataIndex: 'type',
      width:'100px',
      align:'center',
      render:text => (<div>
        {(text===1)?"普通菜单":""}
        {text===2?"跳转菜单":""}
        {(text===3)?"操作菜单":""}
      </div>)
    }, {
      title: '跳转地址',
      dataIndex: 'redirect_url',
      width:'160px',
      align:'center',
    }, {
      title: '图标',
      dataIndex: 'logo_url',
      width:'80px',
      align:'center',
      render:text => (<span>{text?(<img src={text} style={{width:32,height:32}}/>):'无'}</span>)
    },{
      title: '状态',
      dataIndex: 'state',
      width:'80px',
      align:'center',
      render:text => (<div>
            {text===1?"正常":""}
            {text===2?"禁用":""}
      </div>)
    }, {
      title: '创建时间',
      dataIndex: 'created_at',
      width:'120px',
      align:'center',
      render:text => (<span>{text?moment.unix(parseInt(text)).format("YYYY-MM-DD HH:mm:ss"):''}</span>)
    },  {
      title: '菜单顺序',
      dataIndex: 'sort',
      width:'60px',
      align:'center',
    },{
      title: '操作',
      dataIndex: 'operation',
      width:'150px',
      align:'center',
    //   fixed:'right',
      render:(text, record,index) => (<div>
         <a style={{marginRight:10}} onClick={this.updateMenu.bind(this,record)}>更新</a>
         <Popconfirm title="确认禁用菜单吗?" okText="确认" cancelText="取消" onConfirm={()=>this.operateMenu(record)} onCancel={()=>{}}>
            {record.state===1?<a style={{marginRight:10}}>禁用</a>:<a style={{marginRight:10}}>启用</a>}
         </Popconfirm>
         <Popconfirm title="确认删除菜单吗?" okText="确认" cancelText="取消" onConfirm={()=>this.deleteMenu(record)} onCancel={()=>{}}>
            <a>删除</a>
         </Popconfirm>
      </div>)
    }];

    const state_options=[{id: 1,name: '正常'},{id: 2,name: '禁用'}];

    return (
      <div className='layout_content_wrapper'>

       <div className='search_form'>

            <Form layout="inline">
                <Form.Item label="菜单名称">
                    {getFieldDecorator('name', {
                        initialValue:''
                    })(
                        <Input placeholder='请输入菜单名称' style={{width:200}}/>
                    )}
                </Form.Item>

                <Form.Item label="父级菜单">
                    {getFieldDecorator('parent_id', {
                        initialValue:undefined
                    })(
                        <Cascader allowClear fieldNames={{ label: 'name', value: 'id', children: 'children' }} options={parentName_option}
                        loadData={this.loadData} placeholder="请选择" style={{width:200}} changeOnSelect displayRender={this.displayRender}/>
                    )}
                </Form.Item>

                <Form.Item label="状态">
                    {getFieldDecorator('state', {
                        initialValue:undefined
                    })(
                        <Select allowClear placeholder='请选择' style={{width:200}}>
                           {state_options.map(opt=>{
                               return(
                                  <Option key={opt.id} value={opt.id}>{opt.name}</Option>
                               )
                           })}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item>
                   <Button type='primary' onClick={this.searchMenu}>搜索</Button>
                </Form.Item>
            </Form>
             
       </div>

      <div className="add_btn"><Button type="primary" onClick={this.addMenu}>添加菜单</Button></div>
     
      <div className="layout_content_table">
                <Table rowKey='id' scroll={{ x: 1050 }} columns={columns} dataSource={menuList} loading={flag}
                    //    expandIcon={({ expanded, onExpand, record }) =>
                    //     expanded ? (
                    //       <DownOutlined onClick={e => onExpand(record, e)} />
                    //     ) : (<div>
                    //       {record.child===1?
                    //         <RightOutlined onClick={e => onExpand(record, e)} />:''
                    //       }</div>
                    //     )
                    //     }
                       expandedRowKeys={this.state.expandedRowKeys}
                       expandIconColumnIndex={0}
                    //    indentSize={40}
                       pagination={{
                            current: currentPage,
                            pageSize: curPageSize,
                            total: total
                       }}
                       onExpand={this.handleTableExpand}
                       onChange={this.handleTableChange}/>
      </div>

      <EditMenu visible={visible} details={details} cancelModal={this.handleCancel} getMenuList={this.reloadSearchMenu} getParentMenuList={this.getParentMenuList}/>

      </div>
    );
  }
}

Menu = Form.create({
   
})(Menu);
export default Menu;



// WEBPACK FOOTER //
// ./src/page/Menu/Menu.js